<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <!-- <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="error"
        class="mr-3"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template> -->
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseModal')" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>
              Confirma que deseja finalizar as
              {{ isAT ? "iniciativas" : isGov ? "fases" : "soluções" }}?
            </h2>
          </v-col>
        </v-row>

        <v-row
          v-for="municipioSolucao in solutions"
          v-bind:key="municipioSolucao.municipioSolucaoId"
        >
          <v-col>{{ municipioSolucao.nome }}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="$emit('onCloseModal')"
          >Cancelar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from "@/modules/city/API/CitySolutionAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalConfirmFinishSolution",
  props: {
    dialog: { type: Boolean, default: false },
    solutions: { type: Array, required: true },
  },
  computed: {
    ...mapGetters(["user", "isAT", "isGov"]),
  },
  methods: {
    onConfirm() {
      citySolutionAPI
        .finishSolutions(this.solutions)
        .then((resp) => {
          this.$emit("onCloseModal");
        })
        .catch();
    },
  },
};
</script>
